import axios from 'axios';

const defaultState = {
    industrySkills: {},
};

const getters = {
    getSearchbarSkillOptions: (state) => (industry) => {
        if (!Object.keys(state.industrySkills).includes(industry)) {
            return {};
        }
        const skills = state.industrySkills[industry];
        const skillOptions = {};
        for (let skill of skills) {
            skillOptions[skill.skill_id] = skill.skill_name;
        }
        return skillOptions;
    }
};

const mutations = {
    setIndustrySkills(state, {industry, skills}) {
        state.industrySkills[industry] = skills;
    },
};

const actions = {
    async getIndustrySkills({state, commit}, industry) {
        if (!industry) {
            return;
        }
        // Use the already remembered industry skills if we have looked it up for this industry
        if(Object.keys(state.industrySkills).indexOf(industry) !== -1) {
            return state.industrySkills[industry];
        }

        const response = await axios.get('/api/industrySkills', {
            params: {
                'industry': industry
            }
        });

        commit('setIndustrySkills', {
            industry,
            skills: response.data.skills,
        });
        return response.data.skills;
    },
};


export default {
    namespaced: true,
    actions,
    mutations,
    getters,
    state: defaultState,
};
